import React from 'react';
import { View, Image, StyleSheet, TouchableOpacity, TouchableWithoutFeedback, Dimensions } from 'react-native';
// import { 480 } from './../Utils';
import { Text } from './../UI-Components';
import { Surface } from 'react-native-paper';
import Grid from '@material-ui/core/Grid';

const coursesImg = require('./../../assets/courses.png');
const testSeriesImg = require('./../../assets/testSeries_home.png');

const bgTestSeries = require('./../../assets/bgTestSeries.png');
const bgCourses = require('./../../assets/bgCourses.png');
const { width, height } = Dimensions.get("window");

const emblem = require('./../../assets/emblem.png');


export default class Course extends React.Component {
    render() {
        return(

            
            <View style={styles.container}>
            <Grid item xs={6} spacing={6}>
                <TouchableWithoutFeedback
                    onPress={() => this.props.navigation.push('/courseExam')}
                    >
                    <Surface style={[styles.imageWrapper, {backgroundColor: '#0b0837', marginHorizontal: 10,
                        backgroundImage: 'linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(https://secureservercdn.net/198.12.144.78/rph.2dc.myftpupload.com/wp-content/uploads/2020/08/Course-slider-image-01.jpg)',
                        backgroundPosition: 'center center',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundAttachment: 'scroll',
                }]}>
                        <View style={{flexDirection: 'column',marginHorizontal: 20 , marginTop: 25,  }}>
                            <View>
                            {/* <Image source={{uri: 'https://secureservercdn.net/198.12.144.78/rph.2dc.myftpupload.com/wp-content/uploads/2020/08/Classes-Slider-01-scaled.jpg'}} style={{width: 80, height: 80}}></Image> */}
                            </View>
                            <View style={styles.titleCompo}>
                                <Text style={[styles.title, {fontSize: 22}]}>CLASSES</Text>   
                                {/* <Text style={[styles.title, {fontWeight: '600'}]}>RECRUITMENT 2020</Text>    */}
                            </View>
                                
                        </View>
                    </Surface>
                </TouchableWithoutFeedback>
            </Grid>
            <Grid item xs={6} spacing={6}>
                <TouchableWithoutFeedback
                    onPress={() => this.props.navigation.push('/MyTests')}
                >
                    <Surface style={[styles.imageWrapper, {backgroundColor: '#0b0837', marginHorizontal: 10,
                    backgroundImage: 'linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(https://secureservercdn.net/198.12.144.78/rph.2dc.myftpupload.com/wp-content/uploads/2020/08/Classes-Slider-01-scaled.jpg)',
                    backgroundPosition: 'center center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'scroll',
                
                }]} className='bg-course'>
                    <View style={{flexDirection: 'column',marginHorizontal: 20 , marginTop: 25,  }}>
                            <View>
                            {/* <Image source={{uri: 'https://secureservercdn.net/198.12.144.78/rph.2dc.myftpupload.com/wp-content/uploads/2020/08/Course-slider-image-01.jpg'}} style={{width: 80, height: 80}}></Image> */}
                            </View>
                            <View style={styles.titleCompo}>
                                <Text style={[styles.title, {fontSize: 22}]}>EXAMS</Text>   
                                {/* <Text style={[styles.title, {fontWeight: '600'}]}>RECRUITMENT 2020</Text>    */}
                            </View>
                                
                        </View>
                    </Surface>
                </TouchableWithoutFeedback>
            </Grid>
            </View>
        )
    }
}


const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 10,
        paddingVertical: 8,
        // marginHorizontal: 5,
        flexDirection: 'row',
        justifyContent: 'space-around',
        // height: 95,
        width: '100%',
        // marginTop: 75
    },
    imageWrapper: {
        position: 'relative',
        borderColor: '#fff',
        // width: width > 780 ? (window.innerWidth/2) - 30 : (window.innerWidth/2) - 20,
        // alignItems: 'center',
        elevation: 18,
        borderRadius: 10,
        // height: width <= 780 ? 100 : 200,
        height:200,
        // borderWidth: 1,
        // backgroundColor: 'rgba(0,0,0,0.5)',
        justifyContent: 'flex-start',
        // alignItems: 'center',
        overflow: 'hidden',
        borderWidth: 2,

    },
    image: {
        width: width > 780 ? (window.innerWidth/2) - 30 : (window.innerWidth/2) - 20, 
        // maxWidth: 180,
        height: width <= 780 ? 100 : 180,
        resizeMode: 'contain',
        position: 'absolute',
        zIndex: -1,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
        // marginTop: -75
    },
    title: {
        fontSize: width > 780 ?  20 : 12,
        fontWeight: '700',        
        color: '#fff',      
    },
    titleCompo: {
        marginLeft: 20,
        marginTop: 10,
        flexDirection: 'column',
        justifyContent: 'center'
    },
    buttonWrapper: {
        // borderWidth: 1, 
        paddingHorizontal: width > 780 ? 30 : 14,
        paddingVertical: width > 780 ? 14 : 6,
        borderRadius: 10,
        backgroundColor: '#fff',
        borderColor: '#fff',
        marginTop: 4

    }
})


